import styled from 'styled-components';
import { DatePicker } from 'antd';

import theme from '../../../styles/defaultTheme';

export const StyledDatepickerRange = styled(DatePicker.RangePicker)`
    height: 44px;
    min-width: 100px;
    width: 100%;
    border-radius: 8px;
    outline: none;
    border: 1px solid ${(props) => props.theme.lightGreyLink40} !important;
    padding: 0 16px;
    font-size: ${theme.font.size18};
    transition: all 0.3s;
    flex: 1;
    text-transform: uppercase;

    &.error {
        border: 1px solid ${(props) => props.theme.red};
    }

    & svg:hover{
        background-color: ${(props) => props.theme.white} !important;
    }

    &.ant-picker-focused:not(.error),
    &:not(.error):not(.disabled):hover {
        border: 1px solid ${(props) => props.theme.orangeLink} !important;

        .ant-picker-active-bar {
            background: ${(props) => props.theme.orangeLink} !important;
        }
    }

    &.disabled {
        background: ${(props) => props.theme.disabledGrey10};

        .ant-picker-input {
            background: transparent;

            input {
                background-color: transparent !important;
            }
        }
    }

`;
export const SpanError = styled.span`
    color: ${(props) => props.theme.red};
    font-size: ${theme.font.size12};
    margin-top: 4px;
    padding-left: 2px;
`;

export const ContainerInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.white};

    & div {
        background-color: ${(props) => props.theme.white};
        color: ${(props) => props.theme.blackLink} !important;
    }

    & + div {
        position: absolute;
        right: 20px;
        width: 10px;

        &.icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
        }
    }

    .ant-picker:not(.error) {
        border: 1px solid ${(props) => props.theme.lightGrey40};

        &.ant-picker-disabled {
            background: ${(props) => props.theme.disabledGrey10};
            cursor: not-allowed;
            
            & input[disabled] {
                background-color: ${(props) => props.theme.disabledGrey10};
                color: ${(props) => props.theme.grey};
            }
        }
    }

    & .ant-picker-suffix {
        color: ${(props) => props.theme.orange};
        cursor: pointer !important;
    }

    & .ant-picker-clear {
        right: 16px;
    }
`;
